import { render, staticRenderFns } from "./EditChildDialog.vue?vue&type=template&id=47ed3f7a&scoped=true&"
import script from "./EditChildDialog.vue?vue&type=script&lang=js&"
export * from "./EditChildDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditChildDialog.vue?vue&type=style&index=0&id=47ed3f7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ed3f7a",
  null
  
)

export default component.exports